import * as get from 'lodash/get';
import { giftly } from '../../config/api';
import { defaultCreativeSettings } from '../constants/constants';

export const prepareBrandedData = (appState) => {
    const utmSearchParams = new URLSearchParams(
        'utm_source=klickly&utm_medium=marketing&utm_campaign=general&utm_term=general'
    );
    const domain = appState?.promotions?.[0]?.connectedDomain || null;
    const isBrandUnit = appState?.brandId || appState?.campaignId || null;

    const {
        fontName = defaultCreativeSettings.fontName,
        primaryColor = defaultCreativeSettings.primaryColor,
        secondaryColor = defaultCreativeSettings.secondaryColor,
        offerMessage = defaultCreativeSettings.offerMessage,
        logoImage = null,
        coverImages = {}
    } = appState.viewSettings || {};

    let logoSrc = defaultCreativeSettings.logoLocation;
    let linkToOpenOnClick = giftly.baseURL;
    let customImageSrc = '';
    let customMediaType = 'image';
    let overlayType = 'none';
    let overlayProduct = null;

    if (isBrandUnit) {
        const promotionSearchParams = new URLSearchParams(appState?.promotions?.[0]?.utmParams || '');

        if (promotionSearchParams.has('utm_source')) {
            utmSearchParams.set('utm_source', promotionSearchParams.get('utm_source'));
        }

        if (promotionSearchParams.has('utm_medium')) {
            utmSearchParams.set('utm_medium', promotionSearchParams.get('utm_medium'));
        }

        logoSrc = get(logoImage, 'Location', null);

        linkToOpenOnClick = `https://${domain}?${utmSearchParams.toString()}`;

        if (appState.link === 'pdp') {
            linkToOpenOnClick = '';
        }

        if (appState?.customDesignDetails?.redirectUrl) {
            linkToOpenOnClick = appState.customDesignDetails.redirectUrl;
            customImageSrc = appState.customDesignDetails.imageUrl;
            customMediaType = appState.customDesignDetails?.mediaType || 'image';
            overlayType = appState.customDesignDetails?.overlayType ?? 'none';
            if (overlayType !== 'none') overlayProduct = appState?.promotions?.[0] ?? null;
        }
    }

    return {
        isBrandUnit,
        domain,
        linkToOpenOnClick,
        customImageSrc,
        customMediaType,
        overlayType,
        overlayProduct,
        logoSrc,
        offerMessage,
        fontStyles: { fontFamily: fontName },
        buttonStyles: { backgroundColor: primaryColor, fontFamily: fontName },
        messageStyles: { backgroundColor: secondaryColor, color: primaryColor, fontFamily: fontName },
        colors: { primaryColor, secondaryColor },
        coverImages
    };
};
